import { ItemID } from "types/common";

import { getItemClassFromItemId } from "helpers/getItemClassFromItemId";

import { TaxonomyClass } from "modules/TaxonomyModule/consts";
import {
  FOOD_PRODUCT_RELATION,
  MEDICAL_PRODUCT_RELATION,
  RETAIL_PRODUCT_RELATION,
} from "modules/TaxonomyModule/consts/TaxonomyClassRelationsNames";

// Sent to /filter: the products each row must be matched to
export const MATCHED_ITEM_KEY = "matched_item";
// URL-only: restores the panel and the chip; never sent to the API
export const MATCHED_BRAND_KEY = "matched_brand";

export type BrandSourceKey = "medical" | "food" | "retail";

// "Brand" here is the level products are grouped by: the brand, or the product line for food,
// matching each product class's first field in the taxonomy
export type BrandSource = {
  key: BrandSourceKey;
  productClass: TaxonomyClass;
  brandClass: TaxonomyClass;
  // Relation from the product to its group
  brandRelation: string;
  // Translation keys for the group's section title and search placeholder
  titleKey: string;
  placeholderKey: string;
};

// One tab per source, in this order
export const BRAND_SOURCES: BrandSource[] = [
  {
    key: "medical",
    productClass: TaxonomyClass.MEDICAL_PRODUCT,
    brandClass: TaxonomyClass.MEDICAL_BRAND,
    brandRelation: MEDICAL_PRODUCT_RELATION.TO_MEDICAL_BRAND,
    titleKey: "matching.matched_product.brand",
    placeholderKey: "matching.matched_product.brand.placeholder",
  },
  {
    key: "food",
    productClass: TaxonomyClass.FOOD_PRODUCT,
    brandClass: TaxonomyClass.FOOD_PRODUCT_LINE,
    brandRelation: FOOD_PRODUCT_RELATION.TO_FOOD_PRODUCT_LINE,
    titleKey: "matching.matched_product.product_line",
    placeholderKey: "matching.matched_product.product_line.placeholder",
  },
  {
    key: "retail",
    productClass: TaxonomyClass.RETAIL_PRODUCT,
    brandClass: TaxonomyClass.RETAIL_BRAND,
    brandRelation: RETAIL_PRODUCT_RELATION.TO_RETAIL_BRAND,
    titleKey: "matching.matched_product.brand",
    placeholderKey: "matching.matched_product.brand.placeholder",
  },
];

export const getBrandSource = (brandId: ItemID) => {
  const [brandClass] = getItemClassFromItemId(brandId);
  return BRAND_SOURCES.find((source) => source.brandClass.toLowerCase() === brandClass);
};

export const getBrandSourceByKey = (key?: BrandSourceKey) => BRAND_SOURCES.find((source) => source.key === key);
